import merge from '~lodash.mergewith'
import { init } from '~@sentry/vue'
import * as CoreSdk from '~@sentry/core'
import * as BrowserSdk from '~@sentry/browser-sdk'
import { ExtraErrorData, ReportingObserver, RewriteFrames } from '~@sentry/integrations'

export { init }
export const SentrySdk = { ...CoreSdk, ...BrowserSdk }

export function getConfig (ctx) {
  /* eslint-disable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  const config = {
    dsn:"https:\u002F\u002F712dcdf1ea7740ff9e6720913320fa87@o1007958.ingest.sentry.io\u002F4505307657994240",
    environment:"production",
    enabled:true,
    publishRelease:{"org":"teampulse","project":"team-pulse-club-web","authToken":"f759660fbbad48bb9be644b9583e57015c4bc6c1652e44a58a66959d95a65f66","telemetry":false},
    release:"team-pulse-club-web-client@6.0.0+5c53f4d5",
    sourceMapStyle:"hidden-source-map",
  }

  config.integrations = [
    new ExtraErrorData(),
    new ReportingObserver({ types:["crash"] }),
    new RewriteFrames(),
  ]

  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  return config
}
